import { FC, useEffect, useState } from "react"
import { useAuthStore } from "../../hooks/useAuthStore";
import { useNavSectionStore } from "../../hooks/useNavSectionStore";
import { Role } from "../../types/roles/roleTypes";
import { styled } from '@mui/material/styles'
import { AppBar, Box, Button, Grid, IconButton, InputAdornment, MenuItem, Paper, Select, TextField, Toolbar, Typography, Divider, Drawer } from '@mui/material'
import { useDrawerStore } from "../../hooks/useDrawerStore";
import TuneIcon from '@mui/icons-material/Tune';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';


import logoheader from '../../assets/image/logopie.png';
import categoria_prueba from '../../assets/image/categoria_prueba.png';
import fondo_categorias from '../../assets/image/fondo_categorias.png';
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import MenuIcon from '@mui/icons-material/Menu'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AccountPopover from "../../components/common/Header/AccountPopover";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { SearcherKFCProductModal } from "./components/SearcherKFCProductModal";
import { DrawerShoppingCart } from "./components/DrawerShoppingCart";
import SearcherKFCFilterModal from "./components/SearcherKFCFilterModal";
import SearcherKFCPopover from "./components/SearcherKFCPopover";
import SearchProductModal from "./components/SearchProductModal";
import { CustomSearchByTable } from "../../components/common/CustomSearchByTable/CustomSearchByTable";

const categories = [
    { id: 1, name: 'Frenos' },
    { id: 2, name: 'Llantas' },
    { id: 3, name: 'Ventanas' },
    { id: 4, name: 'Motor' },
    { id: 5, name: 'Parabrizas' },
    { id: 6, name: 'Retrovisores' },
    { id: 7, name: 'Frenos' },
    { id: 8, name: 'Llantas' },
    { id: 9, name: 'Ventanas' },
    { id: 10, name: 'Motor' },
    { id: 11, name: 'Parabrizas' },
    { id: 12, name: 'Retrovisores' },
]

const relevances = [
    { id: 1, name: 'Relevancia' },
    { id: 2, name: 'Mejor descuento' },
    { id: 3, name: 'Mayor precio' },
    { id: 4, name: 'Menor precio' }
]

const categoryProduct = [
    {
        id: 1, category: 'Lo más buscado', products: [
            { id: 1, name: 'Llanta' },
            { id: 2, name: 'Llanta' },
            { id: 3, name: 'Llanta' },
            { id: 4, name: 'Llanta' },
            { id: 5, name: 'Llanta' },
            { id: 6, name: 'Llanta' },
            { id: 7, name: 'Llanta' },
            { id: 8, name: 'Llanta' },
            { id: 9, name: 'Llanta' },
            { id: 10, name: 'Llanta' },
        ]
    },
    {
        id: 2, category: 'Descuentos', products: [
            { id: 1, name: 'Llanta' },
            { id: 2, name: 'Llanta' },
            { id: 3, name: 'Llanta' },
            { id: 4, name: 'Llanta' },
            { id: 5, name: 'Llanta' },
            { id: 6, name: 'Llanta' },
            { id: 7, name: 'Llanta' },
            { id: 8, name: 'Llanta' },
            { id: 9, name: 'Llanta' },
            { id: 10, name: 'Llanta' },
        ]
    },
    {
        id: 3, category: 'Nuevo', products: [
            { id: 1, name: 'Llanta' },
            { id: 2, name: 'Llanta' },
            { id: 3, name: 'Llanta' },
            { id: 4, name: 'Llanta' },
            { id: 5, name: 'Llanta' },
            { id: 6, name: 'Llanta' },
            { id: 7, name: 'Llanta' },
            { id: 8, name: 'Llanta' },
            { id: 9, name: 'Llanta' },
            { id: 10, name: 'Llanta' },
        ]
    },
    {
        id: 4, category: 'Para ti', products: [
            { id: 1, name: 'Llanta' },
            { id: 2, name: 'Llanta' },
            { id: 3, name: 'Llanta' },
            { id: 4, name: 'Llanta' },
            { id: 5, name: 'Llanta' },
            { id: 6, name: 'Llanta' },
            { id: 7, name: 'Llanta' },
            { id: 8, name: 'Llanta' },
            { id: 9, name: 'Llanta' },
            { id: 10, name: 'Llanta' },
        ]
    }
]

export const SearcherV2: FC = () => {
    const { user } = useAuthStore()
    const { navOpen, openNavSection } = useNavSectionStore()
    const { shoppingCart, setShoppingCart, openDrawer, drawerOpen } = useDrawerStore()

    const [search, setSearch] = useState<string>('')
    const [showModalProduct, setShowModalProduct] = useState<boolean>(false)
    const [showModalFilter, setShowModalFilter] = useState<boolean>(false)
    const [showSearcher, setShowSearcher] = useState<boolean>(false)
    const [showModalSearch, setShowModalSearch] = useState<boolean>(false)

    const MARGIN_RIGHT = (user.userType == Role.SUPER_ADMIN || user.userType == Role.ADMIN || user.userType == Role.MAINTENANCE || Role.DRIVER) ? 16 : 0
    const BORDER_RADIUS = (user.userType == Role.SUPER_ADMIN || user.userType == Role.ADMIN || user.userType == Role.MAINTENANCE || Role.DRIVER) ? 10 : 0
    const MARGIN_TOP = (user.userType == Role.SUPER_ADMIN || user.userType == Role.ADMIN || user.userType == Role.MAINTENANCE || Role.DRIVER) ? 5 : 0

    const BACKGROUND_COLOR = '#fff'
    const ICON_COLOR_HEADER = '#7a7a7a'
    const HEADER_MOBILE = 64
    const HEADER_DESKTOP = 50

    const NAV_WIDTH = navOpen ? 310 : 28

    useEffect(() => {
        if (search.length > 0) setShowSearcher(true)
        else setShowSearcher(false)
    }, [search])

    const showModal = () => {
        setShowModalSearch(true)
    }

    const StyledRoot = styled(AppBar)(({ theme }) => ({
        backgroundColor: BACKGROUND_COLOR,
        border: 'solid 1px #dddddd',
        boxShadow: 'none',
        [theme.breakpoints.up('lg')]: {
            width: `calc(100% - ${NAV_WIDTH}px)`,
            maxHeight: '75px',
            minHeight: '75px',
            marginRight: MARGIN_RIGHT,
            borderRadius: BORDER_RADIUS,
            marginTop: MARGIN_TOP,
            overflow: 'hidden',
            border: 'solid 1px #dddddd',
        },
    }))

    const StyledToolbar = styled(Toolbar)(({ theme }) => ({
        alignItems: 'center',
        minHeight: HEADER_MOBILE,
        [theme.breakpoints.up('lg')]: {
            minHeight: HEADER_DESKTOP,
            padding: theme.spacing(0, 3),
        },
    }))

    const handleSearch = (event: any) => {
        setSearch(event.target.value);
    }

    const clearSearch = () => {
        setSearch('')
    }

    return (<>
        <StyledRoot>
            <StyledToolbar>
                <IconButton
                    onClick={() => openDrawer(!drawerOpen)}
                    sx={{
                        mr: 1,
                        color: 'text.primary',
                        display: { lg: 'none', xl: 'none' },
                    }}
                >
                    <MenuIcon sx={{ color: ICON_COLOR_HEADER }} />
                </IconButton>

                <Grid mt={2}>
                    <IconButton
                        onClick={() => openNavSection(!navOpen)}
                        sx={{
                            mr: 1,
                            color: 'text.primary',
                            display: { xs: 'none', sm: 'none', md: 'none', lg: 'block', xl: 'block' },
                        }}
                    >
                        <MenuIcon sx={{ color: ICON_COLOR_HEADER }} />
                    </IconButton>
                </Grid>
                <Grid container spacing={2} sx={{ alignItems: 'center', margin: 'auto' }}>
                    {/* <Grid item xs={1} md={1}>
                        <img style={{ width: '70px' }} src={logoheader} alt="logo" />
                    </Grid> */}
                    {!navOpen && <Grid item xs={4.5} md={4}>
                        <Box>
                            <Button sx={{ color: '#000000', fontSize: '12px', fontWeight: 'bolder' }}>Documentos</Button>
                            <Button sx={{ color: '#000000', fontSize: '12px', fontWeight: 'bolder' }}>Beneficios</Button>
                            <Button sx={{ color: '#000000', fontSize: '12px', fontWeight: 'bolder' }}>Autorizaciones</Button>
                        </Box>
                    </Grid>}
                    {navOpen && <Grid item xs={4.5} md={4}>
                    </Grid>}

                    <Grid item xs={4} md={4}>
                        <CustomSearchByTable />
                        {/* <TextField
                            type='text'
                            value={search}
                            onChange={(e) => { handleSearch(e) }}
                            placeholder={'¿Qué estás buscando?'}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    search ? (
                                        <InputAdornment position="end" style={{ cursor: "pointer" }} onClick={() => clearSearch()}>
                                            <CloseIcon fontSize="small" />
                                        </InputAdornment>
                                    ) : null
                                )
                            }}
                            fullWidth
                            sx={{ borderRadius: '5px' }}
                            size="small"
                        /> */}
                    </Grid>
                    <Grid item xs={2} md={3} container justifyContent="flex-end">
                        <IconButton>
                            <ConfirmationNumberIcon fontSize="large" />
                        </IconButton>
                        <IconButton onClick={() => setShoppingCart(true)}>
                            <ShoppingCartIcon fontSize="large" />
                        </IconButton>
                        <IconButton>
                            <AccountCircleIcon fontSize="large" />
                        </IconButton>
                    </Grid>
                </Grid>
            </StyledToolbar>
        </StyledRoot>
        <Grid container spacing={2}>
            <Grid item container xs={12} spacing={2}>
                <Grid item xs={12} md={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <IconButton onClick={() => setShowModalFilter(true)}>
                        <TuneIcon fontSize="large" />
                    </IconButton>
                    <IconButton onClick={showModal}>
                        <SavedSearchIcon fontSize="large" />
                    </IconButton>
                </Grid>
                <Grid item xs={12} md={2} >
                    <Button sx={{ width: '150px', color: '#000000', fontSize: '12px', fontWeight: 'bolder', border: '2px solid #D0D0D0', borderRadius: '15px', margin: '10px' }}>
                        Lo más buscado
                    </Button>
                </Grid>
                <Grid item xs={12} md={2} >
                    <Button sx={{ width: '150px', color: '#000000', fontSize: '12px', fontWeight: 'bolder', border: '2px solid #D0D0D0', borderRadius: '15px', margin: '10px' }}>
                        Descuentos
                    </Button>
                </Grid>
                <Grid item xs={12} md={2} >
                    <Button sx={{ width: '150px', color: '#000000', fontSize: '12px', fontWeight: 'bolder', border: '2px solid #D0D0D0', borderRadius: '15px', margin: '10px' }}>
                        Nuevo
                    </Button>
                </Grid>
                <Grid item xs={12} md={2} >
                    <Button sx={{ width: '150px', color: '#000000', fontSize: '12px', fontWeight: 'bolder', border: '2px solid #D0D0D0', borderRadius: '15px', margin: '10px' }}>
                        Para ti
                    </Button>
                </Grid>
                <Grid item xs={12} md={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Select defaultValue={1} size="small" sx={{ borderRadius: '25px', width: '200px', height: '35px' }}>
                        {relevances?.map((option) => ((<MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>)))}
                    </Select>
                </Grid>
            </Grid>
            {categoryProduct?.map(category => (
                <>
                    <Grid item container xs={12} spacing={2}>
                        <Grid item xs={12} md={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography sx={{ color: 'rgba(0, 0, 0, 0.3)', fontSize: '25px' }}>{category.category}</Typography>
                        </Grid>
                        <Grid item xs={12} md={10} sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                            <Divider sx={{ width: '95%', height: '2px', backgroundColor: 'rgba(0, 0, 0, 0.3)' }} />
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} spacing={2}>
                        {category.products.map(products => (
                            <Grid item xs={12} md={2.4}>
                                <Paper elevation={5} sx={{ width: "100%", height: '270px', margin: '10px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <img style={{ width: '140px', height: '140px' }} src={categoria_prueba} alt="Categoria Prueba" />
                                    <Divider sx={{ width: '100%', height: '1px', backgroundColor: 'rgba(0, 0, 0, 0.3)', marginTop: '5px' }} />
                                    <Grid item sx={{ width: '100%', marginLeft: 'auto' }}>
                                        <Typography fontWeight={'500'} fontSize={'12px'} color={'red'} style={{ textDecoration: 'line-through', marginRight: '10px' }}> $127.350</Typography>
                                        <Typography fontWeight={'500'} fontSize={'12px'}> $127.50</Typography>
                                    </Grid>
                                    <Grid item sx={{ width: '100%', marginLeft: 'auto', display: 'flex', flexDirection: 'column' }}>
                                        <Typography fontWeight={'600'} fontSize={'14px'}>Llanta</Typography>
                                        <Typography fontSize={'12px'}>NISSAN V16 1990-2012</Typography>
                                    </Grid>
                                    <Grid item sx={{ width: '100%' }}>
                                        <Button sx={{ border: '2px solid #D0D0D0', borderRadius: '20px', fontSize: '7px', color: '#707070', height: '25px', margin: '5px' }}
                                            onClick={() => setShowModalProduct(true)}>Ver más</Button>
                                        <Button sx={{ borderRadius: '20px', fontSize: '7px', backgroundColor: '#EBA058', color: '#fff', height: '25px' }}>Añadir al carrito</Button>
                                    </Grid>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </>
            ))}
        </Grid >
        <DrawerShoppingCart />
        {
            showModalProduct &&
            <SearcherKFCProductModal
                open={showModalProduct}
                closeModal={() => setShowModalProduct(false)}
            />
        }
        {
            showModalFilter &&
            <SearcherKFCFilterModal
                open={showModalFilter}
                close={() => setShowModalFilter(false)}
            />
        }
        {
            showModalSearch &&
            <SearchProductModal
                open={showModalSearch}
                closeModal={() => setShowModalSearch(false)}
            />
        }
        {
            showSearcher &&
            <SearcherKFCPopover />
        }
    </>)

}